module.exports = __webpack_public_path__ + "img/sm-2021-04-19_10-41-20.596bb95e.jpg";